<div class="page-content page-fill flex-row">
  <div class="col-sm-4 p-0">
    <div class="mb-1 paddle-header">Paddle Assignment (DoubleClick row to assign paddle)</div>
    @if (auctionPaddleInfos) {
      <div class="grid-fill reconciliation-data-grid" style="max-width: 99%">
        <dx-data-grid
          #paddleDataGrid
          [dataSource]="auctionPaddleInfos"
          keyExpr="id"
          height="100%"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onPaddleToolbarPreparing($event)"
          (onRowDblClick)="paddleRowDoubleClick($event)"
          >
          <dxi-column dataField="paddleNumber" caption="Paddle#" width="100" [sortIndex]="1" [sortOrder]="'asc'" [alignment]="'left'"></dxi-column>
          <dxi-column dataField="assignedTo" caption="Assigned To" width="300"></dxi-column>
          <dxi-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
          <!-- <dxi-column dataField="invoices" caption="Invoices" width="300"></dxi-column> -->
          <dxi-column width="50"></dxi-column>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="paddle-list-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-selection [mode]="'single'"></dxo-selection>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <!-- <button  class="btn btn-sm btn-success" (click)="addPaddle()">Add</button> -->
            <button
              class="btn btn-sm btn-danger me-4"
              (click)="deletePaddleUser(paddleDataGrid.instance.getSelectedRowsData()[0])"
              [disabled]="paddleDataGrid.instance.getSelectedRowsData().length === 0"
              >
              Delete Paddle
            </button>
            <button class="btn btn-sm btn-primary me-4" (click)="createInvoice()">Create Invoice</button>
            <button class="btn btn-sm btn-secondary" (click)="getData()">Refresh Data</button>
            <!-- <button  class="btn btn-sm btn-secondary ms-5" (click)="addPurchase()">Add Purchase</button> -->
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            <!-- <span *ngIf="auctionPaddleInfos" class="me-3" style="font-size: xx-small">
            <strong
              ><em>{{ " DoubleClick Row to Assign Paddle" }}</em></strong
              >
            </span> -->
          </div>
        </dx-data-grid>
      </div>
    }
  </div>
  <div class="col-sm-8">
    @if (auctionItems) {
      <div class="grid-fill reconciliation-data-grid" style="max-width: 99%">
        <dx-data-grid
          #itemDataGrid
          [dataSource]="auctionItems"
          keyExpr="id"
          height="100%"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onRowDblClick)="itemRowDoubleClick($event)"
          (onRowPrepared)="rowPrepare($event)"
          >
          <dxi-column dataField="id" caption="Id" width="70" [sortIndex]="1" [sortOrder]="'asc'" [alignment]="'left'"></dxi-column>
          <!-- <dxi-column dataField="created" caption="Date" dataType="date" width="100"></dxi-column> -->
          <dxi-column dataField="typeNumberDispalyName" caption="Item#" width="100"></dxi-column>
          <dxi-column dataField="type" caption="Type" width="100"></dxi-column>
          <!-- <dxi-column dataField="auctionNumber" caption="#" width="100"></dxi-column> -->
          <dxi-column dataField="name" width="200"></dxi-column>
          <dxi-column dataField="description" caption="Description" width="400"></dxi-column>
          <dxi-column dataField="linePrice" caption="Raffle Price" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
          <dxi-column dataField="donatedBy" caption="Donated By" width="100"></dxi-column>
          <dxi-column dataField="isDonationQualified" caption="Donation?" width="120"></dxi-column>
          <dxi-column dataField="marketValue" caption="Value" width="120"></dxi-column>
          <dxi-column dataField="minimumBid" caption="Min. Bid" width="120"></dxi-column>
          <dxi-column width="120"></dxi-column>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="auction-items-list-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-selection [mode]="'single'"></dxo-selection>
          <dxo-sorting [mode]="'multiple'"></dxo-sorting>
          <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button class="btn btn-sm btn-success ms-2" (click)="addItem()">Add Item</button>
            @if (!reviewOnly) {
              <button
                class="btn btn-sm btn-danger ms-3"
                (click)="deleteItem(itemDataGrid.instance.getSelectedRowsData()[0])"
                [disabled]="itemDataGrid.instance.getSelectedRowsData().length === 0"
                >
                Delete Item
              </button>
            }
            <button class="btn btn-sm btn-secondary ms-5" (click)="addPurchase('item')" [disabled]="itemDataGrid.instance.getSelectedRowsData().length === 0">
              Add Purchase
            </button>
            <!-- <button
            *ngIf="!reviewOnly"
            class="btn btn-secondary ms-1"
            (click)="approveDecline('clear')"
            [disabled]="itemDataGrid.instance.getSelectedRowsData().length === 0"
            >
            Duplicate
          </button> -->
          <!-- <button *ngIf="!reviewOnly" (click)="emailPropsal()" class="btn btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
          Email / Text Vote
        </button>
        <button *ngIf="!reviewOnly" (click)="delete()" class="btn btn-sm btn-danger ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
          Delete
        </button>
        <button *ngIf="!reviewOnly" (click)="print()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
          Print
        </button>
        <button *ngIf="!reviewOnly" (click)="toggleShowAll()" class="btn btn-sm btn-warning ms-2">{{ showAll ? "Show Recent" : "Show All" }}</button> -->
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (auctionItems) {
          <span class="me-3">
            <strong>{{ itemDataGrid.instance.totalCount() + " items" }}</strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
}
</div>
</div>
